import React from 'react'
import MatchChart from 'lib/components/charts/match-chart'
import Container from 'lib/components/charts/container'
import EasingBar from './shapes/easing-bar'
import Grid from 'lib/components/charts/grid'
import GroupsLinear from 'lib/components/charts/layouts/groups-linear'
import SecondaryXAxis from 'lib/components/charts/secondary-x-axis'
import XAxis from 'lib/components/charts/x-axis'
import YAxis from 'lib/components/charts/y-axis'
import Title from './title'

class BarChart extends React.PureComponent {
  static defaultProps = {
    data: [],
    margin: 0.2,
    padding: 0.5,
    primary: 'label',
    secondary: 'categoryShortName',
    width: 300,
    height: 225,
    formatX: n => n,
    formatY: n => n,
    vertical: true
  }

  renderBars(data, x, y) {
    return data.map(record => this.renderBar(record, x, y))
  }

  renderBar(box, x, y) {
    const opacity = box.isActive ? 1 : 0.25
    const width = x.bandwidth()

    return (
      <EasingBar
        id={box.id}
        key={box.x}
        x={x(box.x)}
        y1={y.range()[0]}
        y2={y(box.y)}
        width={width}
        opacity={opacity}
        category={box.category}
        label={box.label}
        fill={box.fill}
      />
    )
  }

  hasManyGroups() {
    let fields = this.props.data.map(d => d[this.props.secondary])

    if (fields.length <= 0) {
      return false
    }

    return fields.some(field => field !== fields[0])
  }

  renderGroup(data, x, y, key, layout) {
    const { formatX, width } = this.props

    const offset = x.bandwidth() * 0.5
    const box = layout.boundingBox

    return (
      <g key={key}>
        {this.renderBars(data, x, y)}

        <MatchChart breakpoint="large" width={width}>
          <XAxis
            scale={x}
            format={formatX}
            ticks={x.domain()}
            y={box.bottom}
            height={box.gutterBottom}
            offset={offset}
            vertical
          />
        </MatchChart>

        <MatchChart breakpoint="small" width={width}>
          <SecondaryXAxis
            data={data}
            scale={x}
            y={box.bottom}
            title={key}
            multi={this.hasManyGroups()}
          />
        </MatchChart>
      </g>
    )
  }

  render() {
    const { data, labelY, formatY, width, height, title } = this.props

    const layout = new GroupsLinear(data, this.props)
    const { scaleX, scaleY } = layout

    return (
      <Container width={width} height={height}>
        <Grid
          scaleX={scaleX}
          scaleY={scaleY}
          ticksX={layout.getTicksX()}
          ticksY={scaleY.ticks(6)}
        />

        <Title x={layout.boundingBox.left} y={layout.boundingBox.top}>
          {title}
        </Title>

        {layout.map(this.renderGroup, this)}

        <YAxis
          label={labelY}
          scale={scaleY}
          format={formatY}
          ticks={layout.getTicksY()}
          height={height}
          width={scaleX.range()[0]}
        />
      </Container>
    )
  }
}

export default BarChart



// WEBPACK FOOTER //
// ./src/components/charts/bar-chart.js